/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   disclosure-button.js
 *
 *   Desc:   Disclosure button widget that implements ARIA Authoring Best Practices
 */

'use strict';

/*
 *   @constructorDisclosureButton
 *
 *
 */
class DisclosureButton {
    constructor(buttonNode) {
        this.buttonNode = buttonNode;
        this.controlledNodes = false;

        var className = this.buttonNode.getAttribute('data-toggle-label');

        if (className) {
            
            this.controlledNodes = document.getElementsByClassName(className);
        }

        this.buttonNode.setAttribute('aria-expanded', 'false');
        this.hideContent();

        this.buttonNode.addEventListener('click', this.onClick.bind(this));
        this.buttonNode.addEventListener('focus', this.onFocus.bind(this));
        this.buttonNode.addEventListener('blur', this.onBlur.bind(this));
    }

    showContent() {
        if (this.controlledNodes) {
            for (let controlledNodeItem of this.controlledNodes) {
                controlledNodeItem.style.display = 'block';
            }
        }
    }

    hideContent() {
        if (this.controlledNodes) {
            for (let controlledNodeItem of this.controlledNodes) {
                controlledNodeItem.style.display = 'none';
            }
        }
    }

    toggleExpand() {
        if (this.buttonNode.getAttribute('aria-expanded') === 'true') {
            this.buttonNode.setAttribute('aria-expanded', 'false');
            if (this.buttonNode.classList.contains('item-list__show-more-less')) {
                this.buttonNode.textContent = SEARCH_DISCLOSURE.messages.VOIR_PLUS;
            }
            this.hideContent();
        } else {
            this.buttonNode.setAttribute('aria-expanded', 'true');
            if (this.buttonNode.classList.contains('item-list__show-more-less')) {
                this.buttonNode.textContent = SEARCH_DISCLOSURE.messages.VOIR_MOINS;
            }
            this.showContent();
        }
    }

    /* EVENT HANDLERS */

    onClick() {
        this.toggleExpand();
    }

    onFocus() {
        this.buttonNode.classList.add('focus');
    }

    onBlur() {
        this.buttonNode.classList.remove('focus');
    }
}

/* Initialize Hide/Show Buttons */

window.addEventListener(
    'load',
    function () {
        var buttons = document.querySelectorAll(
            'button.js-aggregation-label'
        );

        for (var i = 0; i < buttons.length; i++) {
            new DisclosureButton(buttons[i]);
        }
    },
    false
);
